import * as Sentry from '@sentry/nextjs'

interface SectionParam {
	sk: string
}

interface SectionParams {
	[key: string]: {
		[key: string]: {
			[key: string]: string
		}
	}
}

const sectionParams: SectionParams = {
	preventiveExaminations: {
		choosePreventiveExamination: {
			sk: 'vyberte-si-svoju-preventivnu-prehliadku'
		},
		preventiveExaminationDetail: {
			sk: 'preventivna-prehliadka'
		},
		preventiveExaminationCategory: {
			sk: 'preventivna-prehliadka'
		},
		preventiveExaminationProgramsComparison: {
			sk: 'porovnanie-programov'
		},
		preventiveExaminationProgramsPreview: {
			sk: 'prehlad-programov'
		}
	},
	ambulances: {
		chooseAmbulanceCategory: {
			sk: 'vyberte-si-svoju-ambulanciu'
		}
	},
	annualPrograms: {
		chooseProgramCategory: {
			sk: 'vyberte-si-rocny-program'
		},
		annualProgramCategory: {
			sk: 'rocny-program'
		},
		annualProgramDetail: {
			sk: 'program'
		}
	},
	faq: {
		faqDetail: {
			sk: 'skupina'
		}
	},
	medanteCredit: {
		chooseMedanteCreditProgram: {
			sk: 'vyberte-si-svoj-program'
		}
	},
	discounts: {
		discounts: {
			sk: 'akcie'
		}
	},
	creditPackages: {
		chooseCreditPackage: {
			sk: 'vyberte-si-svoj-balik'
		}
	},
	jobs: {
		positions: {
			sk: 'pozicie'
		}
	},
	job: {
		content: {
			sk: 'popis'
		}
	}
}

/** DOM fragment id for the category cards section on `/rocne-programy` (`chooseProgramCategory`). */
export const ANNUAL_PROGRAMS_CHOOSE_CATEGORY_FRAGMENT_ID =
	sectionParams.annualPrograms.chooseProgramCategory.sk

export const useSectionParams = (section: string) => {
	const locale = 'sk'

	const getSectionParams = (child: keyof typeof sectionParams) => {
		try {
			return sectionParams[section][child][locale as keyof SectionParam]
		} catch (error) {
			Sentry.captureException(error)

			return ''
		}
	}

	return {
		getSectionParams
	}
}
